// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BookRentalReturnController from "./book_rental_return_controller"
application.register("book-rental-return", BookRentalReturnController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import ReturnsFormController from "./returns_form_controller"
application.register("returns-form", ReturnsFormController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SearchableBookSelectController from "./searchable_book_select_controller"
application.register("searchable-book-select", SearchableBookSelectController)

import SearchableMemberSelectController from "./searchable_member_select_controller"
application.register("searchable-member-select", SearchableMemberSelectController)

import CustomNumberController from "./custom_number_controller"
application.register("custom-number", CustomNumberController)